<template>
  <!-- 休假申请 -->
  <div>
    <Collapse v-model="value" simple style="border: 0">
      <Panel name="1" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle
          :titleText="
            lang == 'zh' ? chName.BasicInformation : enName.BasicInformation
          "
        />
        <Form
          slot="content"
          :label-width="150"
          label-position="left"
          style="margin: 30px 30px 0 30px"
          disabled
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.createTime : enName.createTime"
              >
                <Input v-model="formItem.createTime" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang == 'zh' ? chName.applyNo : enName.applyNo">
                <Input disabled v-model="formItem.applyNo" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7"> </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.applyName : enName.applyName"
              >
                <Input v-model="formItem.applyName" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.applyUserId : enName.applyUserId"
              >
                <Input v-model="formItem.applyUserId" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.applyPosition : enName.applyPosition
                "
              >
                <Input v-model="formItem.applyPosition" />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="4" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle
          :titleText="
            lang == 'zh'
              ? chName.LeaveApplicationInformation
              : enName.LeaveApplicationInformation
          "
        />
        <Form
          slot="content"
          :model="formItem"
          ref="formItem"
          v-model="formItem"
          :rules="ruleValidate"
          :label-width="165"
          label-position="left"
          style="margin: 30px 30px 0 30px"
          disabled
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="10" :xl="7">
              <FormItem
                :label="lang == 'zh' ? chName.lvType : enName.lvType"
                prop="lvType"
              >
                <Select
                  v-model="formItem.lvType"
                  :clearable="true"
                  placeholder=""
                >
                  <Option
                    :value="item.lvType"
                    v-for="(item, i) in LEAVETYPE"
                    :key="i"
                    >{{ item.lvPolicyNm }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="start">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.lvBeginDt : enName.lvBeginDt"
                prop="lvBeginDt"
              >
                <DatePicker
                  v-model="formItem.lvBeginDt"
                  style="width:100%"
                  :editable="false"
                  type="date"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col :xs="12" :sm="12" :md="12" :lg="12" :xl="3">
              <FormItem
                label=""
                prop="lvBeginTm"
                :label-width="20"
                v-if="unit == 'H' || unit == null"
              >
                <TimePicker
                  v-model="formItem.lvBeginTm"
                  style="margin-left:20px"
                  :editable="false"
                  format="HH:mm"
                  :steps="[1, 30]"
                ></TimePicker>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="start">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.lvEndDt : enName.lvEndDt"
                prop="lvEndDt"
              >
                <DatePicker
                  v-model="formItem.lvEndDt"
                  style="width:100%"
                  :disabled="formItem.lvType == 'M' || formItem.lvType == 'TP'"
                  type="date"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col :xs="12" :sm="12" :md="12" :lg="12" :xl="3">
              <FormItem
                label=""
                prop="lvEndTm"
                :label-width="20"
                v-if="unit == 'H' || unit == null"
              >
                <TimePicker
                  v-model="formItem.lvEndTm"
                  style="margin-left:20px"
                  :disabled="formItem.lvType == 'M' || formItem.lvType == 'TP'"
                  format="HH:mm"
                  :steps="[1, 30]"
                ></TimePicker>
              </FormItem>
            </Col>
          </Row>
          <Row
            type="flex"
            justify="space-between"
            v-if="unit == 'D' || unit == null"
          >
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang == 'zh' ? chName.lvDays : enName.lvDays">
                <Input disabled v-model="formItem.lvDays" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between" v-if="unit == 'H'">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang == 'zh' ? chName.lvHours : enName.lvHours">
                <Input disabled v-model="formItem.lvHours" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="24">
              <FormItem
                span="3"
                :label="lang == 'zh' ? chName.reason : enName.reason"
                prop="reason"
              >
                <Input type="textarea" v-model="formItem.reason" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between" v-show="allowAttcheNull">
            <Col span="18">
              <FormItem
                :label="
                  lang == 'zh' ? chName.file_attachment : enName.file_attachment
                "
                style="margin-top:15px"
              >
                <j2-FileUP
                  ref="file1"
                  @handleDel="fileDel"
                  @handleOK="fileSuc"
                  disabled
                  :file_type="{ resourceType: 'LeaveApplication_Attachment' }"
                  :resourceId="formItem.file_attachment"
                ></j2-FileUP>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <!-- 审批历史 -->
      <Panel name="5" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle
          :titleText="
            lang == 'zh' ? chName.approvalhistory : enName.approvalhistory
          "
        />
        <Table
          border
          :columns="columns3"
          :data="data3"
          slot="content"
          style="margin: 30px 30px 0 30px"
        >
        </Table>
      </Panel>
    </Collapse>
    <Row class="btnRight">
      <Col>
        <Button class="applyBtnRight" v-if="!isHistory" @click="submit">{{
          lang == "zh" ? chName.agree : enName.agree
        }}</Button>
        <Button class="applyBtnRight" v-if="!isHistory" @click="reject">{{
          lang == "zh" ? chName.reject : enName.reject
        }}</Button>
        <Button class="applyBtnRight" @click="returnPage">{{
          lang == "zh" ? chName.return : enName.return
        }}</Button>
      </Col>
    </Row>
    <Modal
      v-model="showdataAgree"
      :title="lang == 'zh' ? chName.approvalopinion : enName.approvalopinion"
      width="500"
      :mask-closable="false"
    >
      <Input v-model="rejectMessage.message" type="textarea" :rows="5"></Input>
      <div slot="footer">
        <Button @click="yess1">{{
          lang == "zh" ? chName.confirm : enName.confirm
        }}</Button>
        <Button @click="cancell1">{{
          lang == "zh" ? chName.cancel : enName.cancel
        }}</Button>
      </div>
    </Modal>
    <Modal
      v-model="showdataRejected"
      :title="lang == 'zh' ? chName.rejectopinion : enName.rejectopinion"
      width="500"
      :mask-closable="false"
    >
      <Form :rules="ruleValidate" :model="rejectMessage" ref="rejectMessage">
        <FormItem prop="message">
          <Input
            v-model="rejectMessage.message"
            type="textarea"
            :rows="5"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="yess2">{{
          lang == "zh" ? chName.confirm : enName.confirm
        }}</Button>
        <Button @click="cancell2">{{
          lang == "zh" ? chName.cancel : enName.cancel
        }}</Button>
      </div>
    </Modal>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>
<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      date: new DateUtil(),
      value: [1, 4, 5],
      formItem: {},
      data3: [],
      spinShow: false,
      LEAVETYPE: [],
      DECEASED: [],
      PUBLICERRANDLEAVE: [],
      TRANSFERLEAVE: [],
      attachmentList: [],
      lvType: "",
      unit: null,
      isHistory: false,
      showdataAgree: false, //审批意见
      showdataRejected: false, //驳回意见
      rejectMessage: {},
      loading: false,
      resourceId_List: [],
      allowAttcheNull: false,
      chName: {},
      enName: {}
    };
  },
  mounted() {
    if (this.getQueryVariable("history")) {
      this.isHistory = true;
    }
    this.getData();
    // 查询国际化
    this.getInternation();
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    ruleValidate() {
      return {
        message: [
          {
            required: true,
            message:
              this.lang == "zh"
                ? this.chName.rejectopinion
                : this.enName.rejectopinion + "！"
          }
        ]
      };
    },
    columns3() {
      return [
        {
          title:
            this.lang == "zh" ? this.chName.stepName : this.enName.stepName,
          key: "stepName",
          align: "center",
          width: "280"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalperson
              : this.enName.approvalperson,
          key: "userName",
          align: "center",
          width: "280"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvaltime
              : this.enName.approvaltime,
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalstatus
              : this.enName.approvalstatus,
          key: "status",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalopinions
              : this.enName.approvalopinions,
          key: "message",
          align: "center",
          width: "465"
        }
      ];
    }
  },
  methods: {
    getInternation() {
      let Obj = {
        viewType: "Leave_Apply",
        beUsed: "1"
      };
      this.spinShow = true;
      axios.post("/International/applySelectViewSet", Obj).then(res => {
        console.log(res);
        this.chName = res.data[0];
        this.enName = res.data[1];
        // console.log(this.chName)
        this.spinShow = false;
      });
    },
    getData() {
      this.loading = true;
      let obj = { instanceId: this.getQueryVariable("instanceId") };
      axios.post("applyLeave/selectApplyLeave", obj).then(res => {
        if (res) {
          this.formItem = res.applyLeave;
          this.$refs.file1.resource_id = this.formItem.fileAttachment
            ? this.formItem.fileAttachment
            : null;
          this.$refs.file1.fileName = this.formItem.fileAttachmentName
            ? this.formItem.fileAttachmentName
            : null;
          this.formItem.createTime = this.date.dateVal(
            this.formItem.createTime,
            "YYYY-MM-DD"
          );
          this.formItem.lvBeginTm = this.date.dateVal(
            this.formItem.lvBeginTm,
            "HH:mm"
          );
          this.formItem.lvEndTm = this.date.dateVal(
            this.formItem.lvEndTm,
            "HH:mm"
          );
          this.lvType = this.formItem.lvType;
          this.data3 = res.logMap;
          let obj2 = {
            serialnumber: res.applyLeave.applySerialnumber
          };
          axios.post("empInfo/employeeSearch", obj2).then(res2 => {
            if (res2) {
              this.$set(this.formItem, "genderCode", res2[0].genderCode);
              this.$set(this.formItem, "maritalCode", res2[0].maritalCode);
              this.$set(this.formItem, "hrstatus", res2[0].hrstatus);
              let obj1 = {
                matchSex: this.formItem.genderCode,
                matchMarried: this.formItem.maritalCode,
                matchEmpType: this.formItem.hrstatus
              };
              axios.post("/lvCode/searchLeaveType", obj1).then(res1 => {
                if (res1) {
                  this.LEAVETYPE = res1;
                  this.LEAVETYPE.forEach(item => {
                    if (item.lvType == this.lvType) {
                      this.unit = item.unit;
                      this.allowAttcheNull =
                        item.allowAttcheNull == 1
                          ? true
                          : item.allowAttcheNull == 0
                          ? false
                          : null;
                    }
                  });
                  console.log(
                    this.formItem.lvType,
                    "unit:" + this.unit,
                    "allowAttcheNull:" + this.allowAttcheNull
                  );
                  this.loading = false;
                } else {
                  this.loading = false;
                }
              });
            } else {
              this.loading = false;
            }
          });
          axios.post("applyLeave/LeaveCheckBox", {}).then(res3 => {
            if (res3) {
              this.DECEASED = res3.DECEASED;
              this.PUBLICERRANDLEAVE = res3.PUBLICERRANDLEAVE;
              this.TRANSFERLEAVE = res3.TRANSFERLEAVE;
            } else {
              this.loading = false;
            }
          });
        } else {
          this.loading = false;
        }
      });
    },
    // 上传附件
    fileSuc(res_id) {
      this.formItem.file_attachment = res_id;
    },
    fileDel(res_id) {
      this.formItem.file_attachment = "";
      this.resourceId_List.push(res_id);
    },
    submit() {
      this.showdataAgree = true;
    },
    reject() {
      this.showdataRejected = true;
    },
    yess1() {
      this.showdataAgree = false;
      let arr1 = [
        {
          objData1: { approval_result: "0" },
          stringData1: this.getQueryVariable("taskId"),
          stringData2: this.rejectMessage.message,
          type: "B17"
        }
      ];
      this.loading = true;
      axios.post("/process/execute", arr1).then(res => {
        this.loading = false;
        if (res) {
          this.$Message.info(this.$t("Approval_Completed"));
          this.$router.push(
            "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
          );
        }
      });
    },
    cancell1() {
      this.showdataAgree = false;
    },
    cancell2() {
      this.showdataRejected = false;
    },
    yess2() {
      this.$refs["rejectMessage"].validate(valid => {
        if (valid) {
          let arr = [
            {
              objData1: { approval_result: "1" },
              stringData1: this.getQueryVariable("taskId"),
              stringData2: this.rejectMessage.message,
              type: "B17"
            }
          ];
          this.showdataRejected = false;
          this.loading = true;
          axios.post("/process/execute", arr).then(res => {
            this.loading = false;
            if (res) {
              this.$Message.info(this.$t("审批驳回成功"));
              this.$router.push(
                "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
              );
            }
          });
        }
      });
    },
    returnPage() {
      if (this.isHistory) {
        this.$router.push(
          "/3911E071298B94E27537586515457CF2BA610C6A6F738319/A3FFBEBFDB713E27"
        );
      } else {
        this.$router.push("/27B8ABB6F63EFBBE75D07D383A598492/A3FFBEBFDB713E27");
      }
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
};
</script>

<style scoped>
.titleDistance {
  margin-top: 25px;
}
.ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
  height: 38px;
  line-height: 38px;
  padding-left: 0px !important;
  color: #666;
  cursor: pointer;
  position: relative;
  border-bottom: 1px solid transparent;
  transition: all 0.2s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/LeaveApplicationApproval.vue